import { Component } from './component';

export interface CheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export class Checkbox extends Component {
  public el: HTMLInputElement;

  constructor(props?: CheckboxProps) {
    super();
    this.el = document.createElement('input');
    this.el.setAttribute('type', 'checkbox');

    if (props?.checked) {
      this.el.setAttribute('checked', 'checked');
    }

    if (props?.disabled) {
      this.el.setAttribute('disabled', 'disabled');
    }

    this.el.addEventListener('change', () => {
      if (props?.onChange) {
        props.onChange(this.el.checked);
      }
    });
  }

  disable() {
    this.el.setAttribute('disabled', 'disabled');
  }

  enable() {
    this.el.removeAttribute('disabled');
  }

  getValue(): boolean {
    return this.el.checked;
  }

  setValue(checked: boolean) {
    this.el.checked = checked;
  }
}
